import React from 'react';
import { Tabs, Tab } from 'react-bootstrap5';
import { Outlet } from 'react-router-dom';

import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';
import { useContext as useUsersContext } from 'components/Users/Context';

import MemberInfo from './MemberInfo/Index';
import RatingsTimeline from './RatingsTimeline/Index';

export default function Content() {
  const { state: stateUsers } = useUsersContext();

  if (stateUsers.user === null) {
    return (
      <LoadingPlaceholder text="Loading..." className="py-5" />
    );
  }

  return (
    <>
      <Tabs
        defaultActiveKey="memberInfo"
        id="members-profile"
        className="d-flex"
        justify
      >
        <Tab
          eventKey="memberInfo"
          title="Member Info"
          className="px-sm-4 px-xxl-5"
        >
          <MemberInfo />
        </Tab>

        <Tab
          eventKey="ratingsTimeline"
          title="Ratings & Timeline"
          className="px-sm-4 px-xxl-5"
        >
          <RatingsTimeline />
        </Tab>
      </Tabs>

      <Outlet />
    </>
  );
}
